<div class="stripe-card" [ngClass]="{ 'stripe-card-setup': isSetupPage }">
  <loading-spinner [show]="isLoading"></loading-spinner>

  <form id="payment-form" class="text-center" #paymentForm (submit)="handleSubmit($event)">
    <div id="payment-element" #paymentElement>
      <!--Stripe.js injects the Payment Element-->
    </div>

    <ng-container *ngIf="!isSetupPage">
      <button id="submit" class="btn btn-primary m-3">
        <div class="spinner hidden" id="spinner"></div>
        <span id="button-text">{{ "PAY_NOW" | translate }}</span>
      </button>
    </ng-container>

    <ng-container *ngIf="isSetupPage">
      <div class="d-flex justify-content-between mt-3">
        <button type="button" class="stripe-card-btn-cancel" (click)="cancelSetup.emit()">
          {{ "BUTTON.CANCEL" | translate }}
        </button>

        <button type="submit" class="stripe-card-btn-submit">
          <span class="d-flex align-items-center">
            {{ "BUTTON.SAVE" | translate }}

            <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
          </span>
        </button>
      </div>
    </ng-container>

    <div id="payment-message" class="hidden"></div>
  </form>
</div>
